var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"local-alert"},[(_vm.localContent)?_c('BaseAlert',{attrs:{"type":_vm.type,"content":_vm.localContent},on:{"dismiss-alert":_vm.dismiss}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }